import React ,{ useState, useEffect } from 'react';
import { Button, Input, Flex, Text } from '@chakra-ui/react';
import { useChainModal } from '@rainbow-me/rainbowkit';
import { useNetwork } from 'wagmi';

    export function NumberMintOpen ({HandleDecrement,MintAmount,HandleIncrement,HandleMint,JsonX,Verify,networkId}) {

    const [btnMintText, setBtnMintText] = useState("");
    const [btnDisable, setBtnDisable] = useState(false);

    const { openChainModal } = useChainModal();
    const { chain } = useNetwork()

    // ตอนนี้เป็นรอบอะไร Public / Whitelist
    // มีรอบอะไรบ้าง
    // รอบต่อไปเกิดตอนไหน

        useEffect(() => {
            Of_iniData()
        },[JsonX])
        
        function Of_iniData() {
            sellStatus()
        }

        function maxPerAddress(){
            //reached max per address
            setBtnMintText("reached max per address.")    
            setBtnDisable(true)
        }

        function sellStatus (){
            
            if (JsonX.totalSupply >= JsonX.collectionSize) {
                // ขายหมด
                setBtnMintText("Sold Out")
                setBtnDisable(true)        
            }
            else if (JsonX.mintPhase == 0) {
                //0 = close
                setBtnMintText("Mint hasn't begun yet")    
                setBtnDisable(true)       
            }
            else if (JsonX.mintPhase == 1) {
                //1 =  Whitelist Round

                if( Boolean(Verify) == false ) {
                    //is whitelisted ?
                    setBtnMintText("You're not Whitelist.")    
                    setBtnDisable(true)
                }
                else if(JsonX.totalSupply >= JsonX.maxWhitelistCanMint ) {
                    setBtnMintText("Exceed max tokens for WL")
                    setBtnDisable(true)   
                }
                else if(JsonX.addressDetailWL >= JsonX.maxPerWhitelist) {
                    //whitelisted but max per address
                    maxPerAddress()                    
                } else {
                    setBtnMintText("Mint")
                    setBtnDisable(false)
                }
        
            }
            else if (JsonX.mintPhase == 2) {
                // 2 = WL closed
                setBtnMintText("AL Round hasn't begun yet")    
                setBtnDisable(true)
            }
            else if (JsonX.mintPhase == 3) {
                // 3 = AL round
                if( Boolean(Verify) == false ) {
                    //is allowlisted ?
                    setBtnMintText("You're not Allowlist.")    
                    setBtnDisable(true)
                }
                else if(JsonX.addressDetailAL >= JsonX.maxPerAllowlist) {
                    //whitelisted but max per address
                    maxPerAddress()                    
                } else {
                    setBtnMintText("Mint")
                    setBtnDisable(false)
                }

            }
            else if (JsonX.mintPhase == 4) {
                // 4 = AL Closed
                setBtnMintText("PB Round hasn't begun yet")    
                setBtnDisable(true)
            }
            else if (JsonX.mintPhase == 5) {
                // 5 = Public Round
                if(JsonX.addressDetailPB >= JsonX.maxPerPublic) {
                    //you already minted - max per address
                    maxPerAddress()
                } else {
                    setBtnMintText("Mint")
                    setBtnDisable(false)
                }
            }
            else if (JsonX.mintPhase == 6) {
                // 6 = Public Round Close
                setBtnMintText("Mint has Ended")
                setBtnDisable(true)
            }
            else {
                //close
                setBtnMintText("Connecting...")
                setBtnDisable(true)
        
            }
        }

    return(
        <div>


                        <Flex 
                            align="center"
                            justify="center"
                        >

                               <Button 
                                   mt='30px'
                                   cursor="pointer"
                                   color="black"
                                   colorScheme="whatsapp"
                                   size='lg'
                                   backgroundColor={btnDisable? "gray":"whatsapp"}
                                   onClick={HandleDecrement}
                                   isDisabled={btnDisable}
                               >
                                   -
                               </Button>
               
                               <Input
                                   mt='30px'
                                   border="0px solid"
                                   readOnly
                                   max-width="100%"
                                   fontSize="20px"
                                   backgroundColor="gray.200"
                                   textAlign="center"
                                   type="number"
                                   background="white"
                                   color="black"
                                   size='lg'
                                   value={MintAmount}
                                   isDisabled={btnDisable}
                               />
               
               
                               <Button
                                   mt='30px'
                                   cursor="pointer"
                                   color="black"
                                   colorScheme="whatsapp"
                                   backgroundColor={btnDisable? "gray":"whatsapp"}
                                   size='lg'
                                   onClick={HandleIncrement}
                                   isDisabled={btnDisable}
                               >
                                   +
                               </Button>
                           </Flex> 

                           {(() => {
                            if (networkId == chain?.id) {

                                // console.log("YES")
                            return( 
                                <Button
                                    mt='30px'
                                    width="100%"
                                    cursor="pointer"
                                    color="black"
                                    colorScheme="whatsapp"
                                    size='lg'
                                    fontSize='25px'
                                    letterSpacing="1.8px"
                                    backgroundColor={btnDisable? "gray":"whatsapp"}
                                    onClick={HandleMint}
                                    isDisabled={btnDisable}
                                    >
                                    {btnMintText}
                                </Button>
                            )
                            } else { 
                                // console.log("NO")
                               return(
                               <Button
                                    mt='30px'
                                    width="100%"
                                    cursor="pointer"
                                    color="black"
                                    colorScheme="yellow"
                                    size='lg'
                                    fontSize='25px'
                                    letterSpacing="1.8px"
                                    // backgroundColor={"yellow"}
                                    onClick={openChainModal}
                              
                                >
                                    Switch chain
                                </Button>
                                )
                                
                            }
                           })()}
                        


                           {/* <Button
                               mt='30px'
                               width="100%"
                               cursor="pointer"
                               color="black"
                               colorScheme="whatsapp"
                               size='lg'
                               fontSize='25px'
                               letterSpacing="1.8px"
                               backgroundColor={btnDisable? "gray":"whatsapp"}
                            //    onClick={() => WLWrite?.()}
                               onClick={HandleMint}
                               isDisabled={btnDisable}
                           >
                               {btnMintText}
                           </Button> */}

        </div>

    )

}